<template>
  <div class="row mt-4 mb-n4 mx-1">
    <v-btn
      fab
      x-small
      color="primary"
      depressed
      @click="handleLeft"
      :disabled="isScrollLeftDisabled"
    >
      <v-icon color="white">mdi-chevron-left</v-icon>
    </v-btn>
    <div class="limited-line">
      <v-tooltip
        color="grey"
        bottom
        v-for="session in filteredPresentations"
        :key="session.codigo"
      >
        <template v-slot:activator="{ on }">
          <v-card
            :id="session.codigo"
            v-on="session.status_venda === 'esgotada' ? on : null"
            min-width="120px"
            max-width="120px"
            min-height="70"
            rounded
            class="card-date mr-2 pa-0"
            :style="`cursor: ${
              session.codigo === eventDetails.codigo ||
              session.status_venda === 'esgotada'
                ? 'default'
                : 'pointer'
            };`"
            :color="
              session.codigo === eventDetails.codigo
                ? 'primary'
                : session.status_venda === 'esgotada'
                ? '#eaeaea'
                : ''
            "
            outlined
          >
            <v-col align="center" @click="handleSelectEvent(session)">
              <v-row justify="center" no-gutters>
                <span
                  class="date"
                  :style="`color: ${
                    session.codigo === eventDetails.codigo ? 'white' : ''
                  }`"
                  >{{
                    firstLetterUppercase(
                      $moment(session.data).format("dddd").replace("-feira", "")
                    )
                  }}</span
                >
              </v-row>
              <v-row justify="center" no-gutters>
                <span
                  class="hour"
                  :style="`color: ${
                    session.codigo === eventDetails.codigo ? 'white' : ''
                  }`"
                  >{{
                    $moment(getFormattedDate(session)).format("DD/MMM - HH:mm")
                  }}</span
                >
              </v-row>
            </v-col>
          </v-card>
        </template>
        <v-row justify="center" no-gutters>
          <span>Esgotado</span>
        </v-row>
      </v-tooltip>
    </div>
    <v-btn
      @click="handleRight"
      class="ml-4"
      fab
      x-small
      color="primary"
      depressed
      :disabled="isScrollRightDisabled"
    >
      <v-icon color="white">mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["filteredPresentations"],
  data() {
    return {
      targetScroll: 0,
      currentScroll: 0,
      isScrollRightDisabled: false,
      isScrollLeftDisabled: false,
    };
  },

  computed: {
    ...mapGetters(["eventDetails"]),
  },

  mounted() {
    const cardEvent = document.getElementById(this.eventDetails.codigo);

    if (cardEvent) {
      let position = cardEvent.getBoundingClientRect();

      const limitedLine = document.getElementsByClassName("limited-line")[0];

      limitedLine.scrollLeft = position.left - 220;
    }
  },

  methods: {
    firstLetterUppercase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    async handleRight() {
      await this.scrollSmoothly(300);
    },

    async handleLeft() {
      await this.scrollSmoothly(-300);
    },

    handleSelectEvent(session) {
      if (session.status_venda !== "esgotada") {
        if (session.codigo === this.eventDetails.codigo) return;
        this.$router.push({ params: { event: session.codigo } });
        this.eventDetails.codigo = session.codigo;
        this.$store.commit("SET_LOADING", true);
      }
    },

    scrollSmoothly(amount) {
      const limitedLine = document.getElementsByClassName("limited-line")[0];
      const targetScroll = limitedLine.scrollLeft + amount;
      const duration = 500;
      const startTime = performance.now();

      function step(currentTime) {
        const elapsedTime = currentTime - startTime;
        const scrollProgress = Math.min(elapsedTime / duration, 1);
        limitedLine.scrollLeft = easeInOutQuad(
          limitedLine.scrollLeft,
          targetScroll,
          scrollProgress
        );

        if (scrollProgress < 1) {
          requestAnimationFrame(step);
        }
      }

      function easeInOutQuad(start, end, progress) {
        return (
          start +
          (end - start) *
            (progress < 0.5
              ? 2 * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 2) / 2)
        );
      }

      requestAnimationFrame(step);
    },

    getFormattedDate(presentation) {
      let splittedDate = `${presentation.data.split(" ")[0]} ${
        presentation.horario_evento
      }:00`;

      return splittedDate;
    },
  },
};
</script>

<style scoped>
.card-date {
  border-radius: 20px !important;
  border: 1px solid #eaeaea;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date {
  font-weight: 500;
}

.hour {
  font-weight: 500;
  font-size: 12px;
}

.limited-line {
  flex: 1;
  white-space: nowrap;
  overflow-x: hidden;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  scroll-behavior: smooth !important;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
